<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="#58595b" title="Users" offset="0">
          <v-text-field
            v-model="searchUsers"
            label="Search"
            single-line
            hide-details
            prepend-icon="mdi-magnify"
            clearable
          ></v-text-field>
          <v-data-table
            key="list"
            :search="searchUsers"
            :headers="headers"
            :items="users"
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                style="color: #4cc7e8"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.id }}</td>
              <td>{{ item.email }}</td>
              <td v-if="item.business_id >= 0">
                {{
                  businessById(item.business_id)
                    ? businessById(item.business_id).name
                    : ""
                }}
              </td>
              <td class="action-col" width="100">
                <v-btn color="blue" dark @click="open(item, 'business')">
                  <v-icon left>mdi-plus</v-icon>Assign Business
                </v-btn>
                <v-btn color="blue" dark @click="open(item, 'impactBusiness')">
                  <v-icon left>mdi-plus</v-icon>Assign Impact Business
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="assignBusinessDialog" persistent max-width="400px">
      <v-card>
        <v-card-text>
          <v-autocomplete
            v-model="formData.business_id"
            :items="businesses"
            :loading="assigningUser"
            item-text="name"
            item-value="id"
            label="Assign to business"
            hide-details
            clearable
          />
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue" dark @click="saveAssignment('Business')"
            >Save Assignment</v-btn
          >
          <v-spacer />
          <v-btn @click="close()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assignImpactBusinessDialog" persistent max-width="400px">
      <v-card>
        <v-card-text>
          <v-autocomplete
            v-model="formData.impactBusiness_id"
            :items="impactBusinesses"
            :loading="assigningUser"
            item-text="company"
            item-value="id"
            label="Assign to impact business"
            hide-details
            clearable
          />
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue" dark @click="saveAssignment('ImpactBusiness')"
            >Save Assignment</v-btn
          >
          <v-spacer />
          <v-btn @click="close()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    assignBusinessDialog: false,
    assignImpactBusinessDialog: false,
    assigningUser: false,
    searchUsers: "",
    formData: {},
    headers: [
      {
        sortable: false,
        text: "ID",
        value: "id",
      },
      {
        sortable: true,
        text: "Email",
        value: "email",
      },
      {
        sortable: true,
        text: "Business",
        value: "business_id",
      },
      {
        sortable: false,
        text: "Action",
      },
    ],
  }),
  computed: {
    ...mapGetters({
      user: "user",
      users: "user/list",
      businessById: "business/businessById",
      businesses: "business/list",
      impactBusinesses: "impactBusinesses/list",
    }),
  },
  mounted() {
    this.$store.dispatch("user/loadUsers");
  },
  methods: {
    open(user, type) {
      if (type === "business") {
        this.assignBusinessDialog = true;
      } else {
        this.assignImpactBusinessDialog = true;
      }

      this.formData = this.$clone(user);
    },
    close() {
      this.assignBusinessDialog = false;
      this.assignImpactBusinessDialog = false;
      this.formData = {};
    },
    saveAssignment(type) {
      this.assigningUser = true;

      if (!this.formData.role.includes(type)) {
        this.formData.role.push(type);
      }

      this.$store.dispatch("user/saveUserProfile", this.formData).then((r) => {
        this.assigningUser = false;
        this.$store.dispatch("user/loadUsers");
        this.assignBusinessDialog = false;
        this.assignImpactBusinessDialog = false;
      });
    },
  },
};
</script>

<style>
.croppa-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.icon-remove {
  position: absolute;
  top: 5px !important;
  right: -35px !important;
}

.croppa-container canvas {
  border: 1px solid;
}
</style>
